export const fonts = {
  default: "font-family: 'Overpass', sans-serif;",
  header: "font-family: 'Work Sans', sans-serif;",
  workSans: "'Work Sans', sans-serif",
  overpass: "'Overpass', sans-serif",
  primary: "'Overpass', sans-serif",
  secondary: "'Work Sans', sans-serif"
};